<script lang="ts" setup>
import SxHero from '~/components/sx/SxHero.vue';
import SxStats from '~/components/sx/SxStats.vue';
import SxPrices from '~/components/sx/SxPrices.vue';
import SxProxyTypes from '~/components/sx/SxProxyTypes.vue';
</script>

<template>
  <main class="sx-main">
    <div ref="hero"><sx-hero class="sx-main__section hero sx-main__section--short" /></div>
    <div ref="content" class="sx-content"><sx-stats /></div>
    <div id="prices" ref="prices"><sx-prices class="sx-main__section sx-main__section--over" /></div>
    <div ref="types"><sx-proxy-types class="sx-main__section sx-main__section--types" /></div>
    <sx-support />
  </main>
</template>

<style lang="scss" scoped>
#prices {
  min-height: 100vh;
}
.sx-main {
  overflow: hidden;
  &__section {
    scroll-snap-align: start;
    z-index: 999;

    &.hero {
      min-height: calc(100vh - 158px);
    }

    &--m2 {
      padding: 4rem 2rem;

      @media (max-width: 480px) {
        padding: 0 2rem;
      }
    }

    &--over {
      min-height: 100vh;
      overflow: hidden;
    }
  }
}

.sx-content {
  margin-top: 116px;
  overflow: hidden;
  background: #fff;
  position: relative;
  z-index: 999;
}

@media (max-width: 1160px) {
  .sx-content {
    margin-top: 10%
  }
}
</style>

